import { createRoot } from "react-dom/client";
import "./app/index.css";
import App from "./App";
import { ConvexProviderWrapper } from "./services/convexClient";

createRoot(document.getElementById("root")!).render(
  <ConvexProviderWrapper>
    <App />
  </ConvexProviderWrapper>
);